<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { PrimitiveProps } from 'radix-vue'

import { cn } from '~ui/lib/utils'

import { buttonIconVariants, type ButtonIconVariants } from '.'

export interface Props extends PrimitiveProps {
  size: ButtonIconVariants['size']
  class?: HTMLAttributes['class']
  name: string
}

const props = defineProps<Props>()
</script>

<template>
  <UiIcon
    :class="cn(buttonIconVariants({ size }), props.class)"
    :name
  />
</template>
